<template>
  <v-data-table :headers="headers" :items="list">
    <template v-slot:item="{ item }">
      <tr>
        <td class="text-sm-left">
          <router-link data-cy="releaseNoteIdLink" :to="`/pack/${packId}/releaseNote/${item.id}/view?tab=release-note`">
            {{ item.id }}
          </router-link>
        </td>
        <td>{{ item.qaAnalystDisplayName || "--" }}</td>
        <td>{{ item.title }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Analyst", value: "qaAnalyst" },
        { text: "Title", value: "title" },
      ],
    };
  },
  async created() {
    try {
      await this.fetchUserList();
    } catch (e) {
      console.error("Error fetching user map:", e);
    }
  },
  methods: {
    ...mapActions({
      fetchUserList: "user/load",
    }),
  },
  props: {
    list: { required: true, type: Array },
    packId: { required: true, type: Number },
  },
};
</script>
